var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { IdStyles } from "../../../../../../less/IdStyles";
import { ReplacementLoca } from "../../../../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../../../../utils/utilNumber";
import { Icon } from "../../../../../generic/icon/Icon";
import { IdIcon } from "../../../../../generic/icon/IdIcon";
import { QuestTask } from "../QuestTask";
export var QuestTaskReachPlayerLevel = function (props) {
    var tasks = props.tasks, questInfoTasks = props.questInfoTasks;
    var task = tasks;
    var list = task.map(function (value) {
        var icon = React.createElement(Icon, { icon: IdIcon.XpIcn, styleId: IdStyles.IconExtraLarge });
        var requiredInfoTask = questInfoTasks.find(function (val) { return val.index === value.index; });
        var currentAmount = requiredInfoTask.amount || 0;
        var taskCompleted = currentAmount >= value.amount;
        var locaReplacements = new Map([
            [ReplacementLoca.zero_0, utilNumber.format(value.amount)],
        ]);
        var taskProps = {
            currentAmount: currentAmount,
            icon: icon,
            locaKey: value.locaKey,
            locaReplacements: locaReplacements,
            requiredAmount: value.amount,
            taskCompleted: taskCompleted,
        };
        return React.createElement(QuestTask, __assign({ key: value.locaKey + "_" + icon }, taskProps));
    });
    return React.createElement("div", { key: "ReachLevelQuest" }, list);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/questTaskReachPlayerLevel/QuestTaskReachPlayerLevel.tsx
// module id = 2677
// module chunks = 3